import { useQuery } from "@tanstack/react-query";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { TextMediumBase, TextMediumSM } from "../../../../Components/Text/MediumText";
import axiosInstance from "../../../../Services/axiosCommon";
import { BackButton } from "../../../../Components/Utils/Buttons";
import NuDate from "../../../../Components/Utils/NuDate";

const ViewProductSupplierList = () => {
  const { productComparisonViewId } = useParams();
  const location = useLocation();

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const { data: fetchedData, isLoading, isFetching } = useQuery({
    queryKey: ["productSupplierList", productComparisonViewId],
    queryFn: async () => {
      const res = await axiosInstance.get(`/supplier-quotations/price-listing/${productComparisonViewId}`);
      return res?.data?.data || null;
    },
    enabled: !!productComparisonViewId,
  });

  const data = fetchedData || location.state?.data;
  const dataLoading = isLoading || isFetching;

  return (
    <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            {
              name: "Product Comparison",
              link: "/procurement/product-comparison/"
            },
            { name: "Product Supplier List" },
          ]} />

        <Link to={"/procurement/product-comparison/"} state={{ currentPage: pageIndex, searchQuery: searchQuery != "" ? searchQuery : "" }}>
          <BackButton link={true} />
        </Link>
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto p-4 rounded-md overflow-y-scroll">
        <TextMediumBase color="text-[#4F4768]" content={`Product Name: ${data?.productName || ''} `} />
        <TextMediumSM color="text-[#4F4768]" content={`Unit: ${data?.unit || ''}`} />
        <table className=' w-full max-h-[calc(100vh-200px)] overflow-y-auto mt-2 '>
          <thead>
            <tr className='border-b border-[#C4C2C2] text-[#4F4768]'>
              <th className=' w-[30%] text-left text-sm font-medium py-2 px-4'>Vendor Name</th>
              <th className=' w-[20%] text-left text-sm font-medium py-2 px-4'>Price</th>
              <th className=' w-[20%] text-left text-sm font-medium py-2 px-4'>Date</th>
            </tr>
          </thead>
          <tbody>
            {dataLoading ? (
              <tr>
                <td colSpan={3}>
                  <div className="w-full h-[40vh] flex justify-center items-center">
                    <div className="flex flex-row gap-2">
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.3s]" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.5s]" />
                      <div className="w-3 h-3 rounded-full bg-baseColor-primary animate-bounce [animation-delay:-.7s]" />
                    </div>
                  </div>
                </td>
              </tr>
            ) : data?.quotes && data.quotes.length > 0 ? (
              data.quotes.map((value, index) => {
                return (
                  <tr key={index} className='even:bg-white odd:bg-slate-50 ' >
                    <td className=' w-[30%] py-2 text-left text-xs px-4 text-[#606279]'>{value?.vendorName}</td>
                    <td className='w-[30%] py-2 text-left text-xs px-4 text-[#606279]'>
                      {value?.currency}{" "}
                      {value?.price
                        ? new Intl.NumberFormat('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }).format(value.price)
                        : "0.00"}
                    </td>
                    <td className=' w-[30%] py-2 text-left text-xs px-4 text-[#606279]'>{value?.date && NuDate({ value: value?.date, format: "DD-MMM-YYYY" })}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={3} className="text-center py-12 text-gray-400 text-xs">
                  No supplier quotes found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ViewProductSupplierList;